import { Collapse, Flex, Table } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * Data Preview Table Component
 * Shows a preview of data (top 5 rows) with option to expand full data.
 *
 * @param {Array} dataSource - Table data source
 * @param {Array} columns - Table column definitions
 * @param {number} previewRows - Number of rows to show in preview (default: 5)
 * @param {number} maxPreviewRows - Maximum number of rows before showing collapse (default: 20)
 */
function DataPreviewTable({ dataSource, columns, previewRows = 5, maxPreviewRows = 20 }) {
  if (dataSource.length <= maxPreviewRows) {
    return (
      <Flex vertical gap={8}>
        {dataSource.length} rows total
        <Table
          dataSource={dataSource}
          columns={columns}
          pagination={false}
          size="small"
          scroll={{ x: true }}
        />
      </Flex>
    );
  }

  const previewData = dataSource.slice(0, previewRows);
  const items = [
    {
      key: 1,
      label: 'Show full data',
      children: (
        <Table
          dataSource={dataSource}
          columns={columns}
          pagination={{ pageSize: 50 }}
          size="small"
          scroll={{ x: true }}
        />
      ),
    },
  ];

  return (
    <Flex vertical gap={8}>
      Preview (top {previewRows} rows) — {dataSource.length} rows total
      <Table
        dataSource={previewData}
        columns={columns}
        pagination={false}
        size="small"
        scroll={{ x: true }}
      />
      {dataSource.length > previewRows && <Collapse ghost items={items} />}
    </Flex>
  );
}

DataPreviewTable.propTypes = {
  dataSource: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ).isRequired,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      dataIndex: PropTypes.string,
      key: PropTypes.string,
    }),
  ).isRequired,
  previewRows: PropTypes.number,
  maxPreviewRows: PropTypes.number,
};

export default DataPreviewTable;
